import React, { ChangeEvent, useCallback, useState } from 'react';

import { Box, VisuallyHidden } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { ActionButton, ActionButtonVariants } from 'components/action-button';
import { useDeliveryAddressModalContext } from 'components/address-modal/delivery-address-modal.context';
import { ActionStatus } from 'components/address-modal/types';
import { useMediaQuery } from 'hooks/use-media-query';

import { DeliveryTerms } from '../../delivery-terms';

import { NameInput, StyledModalHeader } from './styled';

export const OtherLocation = () => {
  const [location, setLocation] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');
  const { deliveryAddressLocations, setDeliveryAddressLocations, dispatchDeliveryAddressState } =
    useDeliveryAddressModalContext();

  const handleClick = useCallback(() => {
    if (!location) {
      setErrorMessage(formatMessage({ id: 'requiredField' }));
    } else {
      //@ts-ignore
      setDeliveryAddressLocations([...deliveryAddressLocations, location]);
      dispatchDeliveryAddressState({ type: ActionStatus.SAVE_DELIVERY_ADDRESS_OTHER_LOCATION });
    }
  }, [
    deliveryAddressLocations,
    dispatchDeliveryAddressState,
    formatMessage,
    location,
    setDeliveryAddressLocations,
  ]);

  const handleBack = useCallback(() => {
    dispatchDeliveryAddressState({ type: ActionStatus.SAVE_DELIVERY_ADDRESS_OTHER_LOCATION });
  }, [dispatchDeliveryAddressState]);

  const handleInputChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setLocation(e.currentTarget.value);
  }, []);

  return (
    <>
      <StyledModalHeader data-testid="other-location-address-header">
        {formatMessage({ id: 'otherLocation' })}
      </StyledModalHeader>
      <Box>
        <NameInput
          autoFocus
          required
          name={'addressLine1'}
          errorMessage={errorMessage}
          data-testid="location-address-input"
          data-private="redact"
          data-dd-privacy="mask"
          label={formatMessage({ id: 'name' })}
          aria-label={formatMessage({ id: 'name' })}
          onChange={handleInputChange}
          value={location}
        />
      </Box>
      {!!location && (
        <VisuallyHidden role="alert">
          {`${formatMessage({ id: 'thereIsAnErrorInThisForm' })}.  `}
        </VisuallyHidden>
      )}
      <DeliveryTerms />
      <Box center margin="2rem 0 0">
        <Box width={isDesktop ? '50%' : '100%'} center margin="0 0 1rem">
          <ActionButton
            fullWidth
            disabled={false}
            isLoading={false}
            onClick={handleClick}
            data-testid="save-here"
            variant={ActionButtonVariants.PRIMARY}
          >
            {formatMessage({ id: 'save' })}
          </ActionButton>
        </Box>
      </Box>
      <Box>
        <Box width={isDesktop ? '50%' : '100%'} center margin="0 auto 1rem auto">
          <ActionButton
            fullWidth
            disabled={false}
            isLoading={false}
            onClick={handleBack}
            data-testid="go-back"
            variant={ActionButtonVariants.OUTLINE}
          >
            {formatMessage({ id: 'back' })}
          </ActionButton>
        </Box>
      </Box>
    </>
  );
};
